import React from 'react'
import './Dharini';

const CircleImpact = () => {
    return (
      <div className='dhacircle'>
        <div className='dhax-box'>
          <div className='dhhax-box-cont'>
            {/* <h1>Seasons of year</h1> */}
            <strong id='d'>Revenue Generated for Artisans : 10</strong>
            <strong  id='e'>Entrepreneur Created : 20</strong>
            <strong  id='f'>Artisans Impacted : 10</strong>
            <strong  id='g'>People impacted indirectly:10</strong>
          </div>
            
        </div>
        </div>
    )
}

export default CircleImpact
